import type { CSSProperties } from 'react'
import { useContent } from '../content/ContentContext'
import { socialLinks } from '../content/socialLinks'

export function SocialRail() {
  const items = socialLinks(useContent().settings)
  if (items.length === 0) return null

  return (
    <div
      aria-label="Redes sociales"
      className="social-rail"
      style={{
        position: 'fixed', right: 16, top: '50%', transform: 'translateY(-50%)',
        zIndex: 60, display: 'flex', flexDirection: 'column', gap: 10,
      }}
    >
      {items.map(({ href, label, color, Icon }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener"
          title={label}
          className="rail-link"
          style={{
            ['--brand']: color,
            width: 44, height: 44, borderRadius: '50%', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 6px 18px rgba(21,35,63,.18)',
          } as CSSProperties}
        >
          <Icon size={20} title={label} />
        </a>
      ))}
    </div>
  )
}
